export default "__VITE_ASSET__c6bc88c0__"